import { render, staticRenderFns } from "./PageVesting.vue?vue&type=template&id=0dbbbd4c"
import script from "./PageVesting.vue?vue&type=script&lang=js"
export * from "./PageVesting.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports